<template>
	<div
		class="grid grid-cols-[auto_1fr_auto_auto] w-full text-left h-fit bg-white"
	>
		<LoanApplicationDocumentsRow
			v-for="doc in documents"
			:key="doc.id"
			:doc
			:data-selected="doc.id === selectedDocument?.id"
			class="hover:bg-gray-50 data-[selected=true]:bg-gray-100"
			@selected="emit('selected', doc)"
		/>
	</div>
</template>

<script lang="ts" setup>
import type { HdnRequestedDocument } from "@/composables/useLoanApplicationSortedDocuments";

defineProps<{
	documents: HdnRequestedDocument[];
	selectedDocument?: HdnRequestedDocument | null;
}>();

const emit = defineEmits<{
	(e: "selected", doc: HdnRequestedDocument): void;
}>();
</script>
